/**
 * Canonical Firestore conversationId for patient ↔ care team messaging (Phase 4).
 * One thread per patient so all assigned care managers share history; legacy messages
 * used sorted(patientId, cmUid) and are still counted on the dashboard.
 */
export function getPatientCareTeamThreadId(patientId) {
  const a = String(patientId || '').trim();
  if (!a) return '';
  return `careteam_${a}`;
}
